<template>
    <svg
        width="138"
        height="31"
        viewBox="0 0 138 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            y="0.5"
            width="138"
            height="30"
            rx="15"
            fill="black"
            fill-opacity="0.2"
        />
        <g clip-path="url(#clip0_2867_14362)">
            <path
                d="M20.9825 6.5C21.6659 7.80462 22.3691 9.187 23.5812 10.09C24.154 10.5404 24.9387 10.747 25.6431 10.5032C26.8156 10.1202 27.8005 9.33093 28.6912 8.50335C28.5014 9.76502 28.2849 11.0221 28.0951 12.2826C29.2303 12.7051 30.0313 13.8924 29.9987 15.1007C30.0267 16.1128 29.5924 17.0704 29.0591 17.9096C28.0788 19.4115 26.7387 20.6349 25.3451 21.7492C24.1435 22.7098 23.5614 23.2232 20.9999 24.5C18.4385 23.2813 17.6817 22.5669 16.6525 21.7468C15.3415 20.7022 14.0864 19.5589 13.1212 18.1812C12.4995 17.2724 11.972 16.2208 12.0012 15.0938C11.9709 13.8878 12.7708 12.7051 13.9048 12.2826C13.715 11.0221 13.4973 9.76502 13.3086 8.50335C14.218 9.34834 15.2262 10.1597 16.4336 10.5264C17.2079 10.769 18.0298 10.4498 18.6166 9.93681C19.6901 9.02218 20.3992 7.76283 20.9825 6.5ZM13.5869 14.7711C13.8454 16.1929 14.6662 17.4384 15.5918 18.5201C17.1287 20.282 19.0009 21.7329 20.9999 22.9389C22.4157 22.0927 23.7523 21.1096 24.969 19.9977C26.3091 18.7465 27.5863 17.3234 28.2069 15.5708C28.5876 14.5297 28.5736 13.3434 28.073 12.3429C27.4245 12.7944 26.6526 13.0092 25.8946 13.1972C24.5184 13.5222 23.1096 13.7009 21.6985 13.7845C19.9206 13.8483 18.1416 13.629 16.4033 13.2668C15.5476 13.0649 14.6627 12.8536 13.9304 12.3441C13.566 13.0916 13.4251 13.9528 13.5869 14.7711Z"
                fill="url(#paint0_linear_2867_14362)"
            />
            <g filter="url(#filter0_d_2867_14362)">
                <path
                    d="M21.0018 20.1001C22.3048 19.2845 24.7792 17.2535 26.0781 15.1001C24.8523 15.8354 22.25 16.0767 21.0018 16.072C19.7535 16.0672 17.0469 15.7744 15.9219 15.1001C17.0151 17.4405 19.5189 19.1781 21.0018 20.1001Z"
                    fill="white"
                />
            </g>
        </g>
        <path
            d="M43.956 19H42.156V12.58H39.168V10.96H46.944V12.58H43.956V19ZM51.7294 19.12C49.0654 19.12 47.4094 17.488 47.4094 14.98C47.4094 12.472 49.0654 10.84 51.7294 10.84C54.4534 10.84 56.0974 12.472 56.0974 14.98C56.0974 17.488 54.4534 19.12 51.7294 19.12ZM51.7294 17.392C53.4934 17.392 54.1774 16.768 54.1774 14.98C54.1774 13.192 53.4934 12.568 51.7294 12.568C49.9654 12.568 49.3174 13.192 49.3174 14.98C49.3174 16.768 49.9654 17.392 51.7294 17.392ZM58.6823 19H56.8823V10.96H61.0823C62.9423 10.96 64.1423 12.016 64.1423 13.864C64.1423 15.712 62.9423 16.78 61.0823 16.78H58.6823V19ZM60.8903 12.58H58.6823V15.16H60.8903C61.8863 15.16 62.3543 14.872 62.3543 13.864C62.3543 12.88 61.8863 12.58 60.8903 12.58ZM71.6483 19H66.5963V10.96H71.4203C73.0643 10.96 73.9523 11.656 73.9523 12.916C73.9523 13.912 73.4243 14.632 72.0803 14.728V14.836C73.5683 14.944 74.2883 15.688 74.2883 16.768C74.2883 18.136 73.4483 19 71.6483 19ZM68.3963 12.58V14.152H71.2163C71.8763 14.152 72.1523 13.924 72.1523 13.372C72.1523 12.82 71.8643 12.58 71.1923 12.58H68.3963ZM68.3963 15.64V17.38H71.4323C72.1643 17.38 72.4643 17.152 72.4643 16.504C72.4643 15.868 72.1643 15.64 71.4323 15.64H68.3963ZM79.0927 19.12C76.4287 19.12 74.7727 17.488 74.7727 14.98C74.7727 12.472 76.4287 10.84 79.0927 10.84C81.8167 10.84 83.4607 12.472 83.4607 14.98C83.4607 17.488 81.8167 19.12 79.0927 19.12ZM79.0927 17.392C80.8567 17.392 81.5407 16.768 81.5407 14.98C81.5407 13.192 80.8567 12.568 79.0927 12.568C77.3287 12.568 76.6807 13.192 76.6807 14.98C76.6807 16.768 77.3287 17.392 79.0927 17.392ZM88.3856 19.12C85.7216 19.12 84.0656 17.488 84.0656 14.98C84.0656 12.472 85.7216 10.84 88.3856 10.84C91.1096 10.84 92.7536 12.472 92.7536 14.98C92.7536 17.488 91.1096 19.12 88.3856 19.12ZM88.3856 17.392C90.1496 17.392 90.8336 16.768 90.8336 14.98C90.8336 13.192 90.1496 12.568 88.3856 12.568C86.6216 12.568 85.9736 13.192 85.9736 14.98C85.9736 16.768 86.6216 17.392 88.3856 17.392ZM97.1866 19.12C94.7506 19.12 93.3826 18.16 93.3826 16.288V16.216H95.1826V16.432C95.1826 17.176 95.5546 17.476 97.1866 17.476C98.6266 17.476 98.9626 17.26 98.9626 16.72C98.9626 16.228 98.6866 16.048 97.8586 15.904L95.6026 15.58C94.1626 15.352 93.3106 14.632 93.3106 13.324C93.3106 12.112 94.2946 10.84 96.9946 10.84C99.4666 10.84 100.619 11.98 100.619 13.672V13.744H98.8066V13.576C98.8066 12.808 98.4106 12.484 96.8146 12.484C95.5186 12.484 95.1226 12.736 95.1226 13.252C95.1226 13.72 95.3866 13.888 96.0586 14.008L98.3146 14.368C100.115 14.656 100.763 15.532 100.763 16.636C100.763 17.944 99.7426 19.12 97.1866 19.12ZM105.972 19H104.172V12.58H101.184V10.96H108.96V12.58H105.972V19ZM116.409 19H109.605V10.96H116.409V12.58H111.405V14.152H116.229V15.76H111.405V17.38H116.409V19ZM119.022 19H117.222V10.96H121.662C123.642 10.96 124.77 11.836 124.77 13.372C124.77 14.68 124.014 15.46 122.502 15.604V15.7C123.222 15.892 123.498 16.276 123.798 16.84L124.962 19H122.874L121.77 16.912C121.446 16.288 121.146 16.084 120.21 16.084H119.022V19ZM119.022 12.58V14.728H121.65C122.502 14.728 122.886 14.488 122.886 13.648C122.886 12.856 122.502 12.58 121.65 12.58H119.022Z"
            fill="white"
        />
        <defs>
            <filter
                id="filter0_d_2867_14362"
                x="9.51562"
                y="8.69384"
                width="22.9688"
                height="17.8125"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="3.20313" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.356863 0 0 0 0 0.909804 0 0 0 0 0.784314 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_2867_14362"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_2867_14362"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_2867_14362"
                x1="12"
                y1="7.10217"
                x2="31.8864"
                y2="9.44663"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#77F9A2" />
                <stop offset="0.264137" stop-color="#65EDA9" />
                <stop offset="0.508928" stop-color="#59E8CB" />
                <stop offset="0.743303" stop-color="#57CFE9" />
                <stop offset="1" stop-color="#47ADE2" />
            </linearGradient>
            <clipPath id="clip0_2867_14362">
                <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(12 6.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {
    data() {
        return {};
    },
};
</script>
